// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".col_text[data-v-0ebc12ba]{text-align:center;margin-bottom:50px}", ""]);
// Exports
module.exports = exports;
